var clientDetails = (function () {
  const init = function () {
    const id = $("#Id").val();
    $("#can-use-api").on("click", function () {
      if ($(this).is(':checked')) {
        activateClientApi(id);
      } else {
        deactivateClientApi(id);
      }
    });

    $("#client-tanks-datatable").DataTable({
      autoWidth: false,
      stateSave: true,
      responsive: true,
      columnDefs: [{ orderable: false, targets: 4 }],
      language: {
        url: "https://cdn.datatables.net/plug-ins/1.10.19/i18n/Ukrainian.json",
        //TODO: make it depends on current culture not on sdn call
      },
    });

    $("#client-tanks-datatable").on("click", ".mdi-calculator", function () {
      const fuelTankId = $(this).data("client-id");
      $.ajax({
        url: `/Clients/ReCalculateFifo/${fuelTankId}`,
        method: "PUT",
        contentType: "application/json",
      }).done(function (data) {
        $.showNotification(data.header, data.message, data.succeed);
      });
    });

    function activateClientApi(id) {
      $.ajax({
        url: `/Clients/ActivateClientApi/${id}`,
        method: "PUT",
        contentType: "application/json",
      }).done(function (data) {
        $.showNotification(data.header, data.message, data.succeed);
      });
    }

    function deactivateClientApi(id) {
      $.ajax({
        url: `/Clients/DeactivateClientApi/${id}`,
        method: "PUT",
        contentType: "application/json",
      }).done(function (data) {
        $.showNotification(data.header, data.message, data.succeed);
      });
    }
  };

  return {
    init: init,
  };
})();
